import { Link } from 'react-router-dom';

const situations = [
  {
    icon: 'ri-arrow-up-line',
    title: 'Selling to Move to a Larger Home',
    description:
      'Growing family? Need more space? Carol can help you plan your move-up while maximising the return on your current property.',
  },
  {
    icon: 'ri-arrow-down-line',
    title: 'Downsizing',
    description:
      'Ready for a smaller, more manageable home? Get help understanding your equity and finding the right next chapter.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Relocating',
    description:
      'Moving for work, family or a change of scenery? Carol can help you coordinate the sale while managing the logistics of relocation.',
  },
  {
    icon: 'ri-heart-line',
    title: 'Selling an Inherited Property',
    description:
      'Handling a loved one\'s property can be emotionally challenging. Carol provides patient, respectful guidance through the process.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Selling After a Change in Circumstances',
    description:
      'Life changes — and your housing needs change too. Carol offers understanding support with no judgement, just practical help.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Preparing a Property That Needs Updating',
    description:
      'Not every home is show-ready. Carol can advise on which updates matter most and which you can skip — helping you sell without overspending.',
  },
  {
    icon: 'ri-arrow-go-back-line',
    title: 'Re-listing a Home That Did Not Previously Sell',
    description:
      'A previous attempt did not work out? Carol will help you understand what may have gone wrong and create a fresh approach.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Understanding Whether Now Is the Right Time',
    description:
      'Not sure if you should sell now or wait? Carol provides honest market insight so you can make a confident, informed decision.',
  },
];

export default function SituationsHelp() {
  return (
    <section className="py-16 md:py-24 bg-background-100/70">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <h2 className="font-heading text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-4">
            Situations Carol Can Help With
          </h2>
          <p className="text-foreground-600 font-body text-base max-w-[600px] mx-auto">
            Every homeowner's situation is different. Whatever your reason for
            considering a sale, Carol has likely helped someone in a similar
            position.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {situations.map((s, i) => (
            <Link
              key={i}
              to="/sell-your-home"
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${s.icon} text-accent-700 text-lg`} />
              </div>
              <h3 className="font-heading text-foreground-900 text-base mb-2 group-hover:text-primary-600 transition-colors">
                {s.title}
              </h3>
              <p className="text-foreground-600 font-body text-xs leading-relaxed">
                {s.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}